import z from 'zod';

export const ValidateCreateVacancySchema = z
  .object({
    name: z.string().min(1, 'Название вакансии обязательно'),
    companyId: z.string().min(1, 'Выберите компанию'),
    cityIds: z.array(z.string()).min(1, 'Выберите хотя бы один город'),
    currencyId: z
      .string({ message: 'Выберите валюту' })
      .min(1, 'Выберите валюту'),
    salaryFrom: z
      .number({ message: 'Введите минимальную зарплату' })
      .min(1, 'Зарплата должна быть больше 0'),
    salaryTo: z
      .number({ message: 'Введите максимальную зарплату' })
      .min(1, 'Зарплата должна быть больше 0'),
    mandatoryRequirements: z
      .string()
      .min(1, 'Обязательные требования необходимы'),
    additionalRequirements: z
      .string()
      .min(1, 'Дополнительные требования необходимы'),
    responsibilities: z.string().min(1, 'Обязанности необходимы'),
    employmentTypeIds: z
      .array(z.string(), { message: 'Выберите хотя бы один тип занятости' })
      .min(1, 'Выберите хотя бы один тип занятости'),
    paymentPeriodId: z
      .string({ message: 'Выберите период выплат' })
      .min(1, 'Выберите период выплат'),
    scheduleWorkIds: z
      .array(z.string(), { message: 'Выберите график работы' })
      .min(1, 'Выберите график работы'),
    skills: z.array(z.string()).optional(),
    activitySphereIds: z.array(z.string()).optional(),
    ai_sphere_fill: z.boolean(),
    activeFrom: z.date({ message: 'Дата начала активности обязательна' }),
    activeTo: z.date({ message: 'Дата окончания активности обязательна' }),
    responsibleUserId: z
      .string({ message: 'Выберите ответственного сотрудника' })
      .min(1, 'Выберите ответственного сотрудника'),
    requiredCandidatesCount: z
      .string({ message: 'Выберите количество кандидатов' })
      .min(1, 'Выберите количество кандидатов'),
    tariffId: z
      .string({ message: 'Выберите тариф' })
      .nonempty('Выберите тариф'),
    interviewFinalMessage: z.string().optional(),
  })
  .refine(data => data.salaryTo >= data.salaryFrom, {
    message: 'Максимальная зарплата должна быть больше или равна минимальной',
    path: ['salaryTo'],
  });

export type VacancyCreateFormValues = {
  name: string;
  companyId?: string | undefined;
  cityIds: string[];
  requiredCandidatesCount: string | undefined;
  responsibleUserId: string | undefined;
  currencyId: string | undefined;
  salaryFrom: number | undefined;
  salaryTo: number | undefined;
  mandatoryRequirements: string;
  additionalRequirements: string;
  responsibilities: string;
  employmentTypeIds: string[];
  paymentPeriodId: string | undefined;
  scheduleWorkIds: string[];
  activeFrom: Date | null;
  activeTo: Date | null;
  interviewFinalMessage: string;
  activitySphereIds: string[];
  ai_sphere_fill: boolean;
  tariffId: string;
  skills: string[];
};
